import { $api } from '#/api/client'

interface IPendingActionsStats {
  pendingImports: number
  pendingSubscriptions: number
  pendingPhotoApprovals: number
  pendingUserData: number
  pendingETickets: number
}

interface IFetchPendingActionsStatsResponse {
  stats: IPendingActionsStats | undefined
  isLoading: boolean
  isError: boolean
}

export const useFetchPendingActionsStats = (): IFetchPendingActionsStatsResponse => {
  const { data, isLoading, isError } = $api.useQuery(
    'get',
    '/stats/pending-actions',
    {},
    {
      select: (response): IPendingActionsStats => ({
        pendingImports: response.pendingImports,
        pendingSubscriptions: response.pendingSubscriptions,
        pendingPhotoApprovals: response.pendingPhotoApprovals,
        pendingUserData: response.pendingUserData,
        pendingETickets: response.pendingETickets,
      }),
    },
  )

  return {
    stats: data,
    isLoading,
    isError,
  }
}
